/**
 * Why the backend answered 401 (GROWTH-7362).
 *
 * api-v2 and json-api tell the reasons apart with a code after `#` in the message of a
 * `{ ok: false, error: "Login is required#<code>" }` body (`Apiv2_AbstrController::preDispatch`,
 * `JsonApi_AbstrController::preDispatch`, json-api `FeedController`). Both backends pin the codes in their tests.
 */

export const UNAUTHORIZED_REASON = {
  /** The token is valid, but no member belongs to it. Signing out and in again cannot fix that. */
  NO_MEMBER: "no-member",
  /** The token is missing, empty or refused. A fresh token, or a new sign-in, can fix that. */
  TOKEN: "token",
  /** Anything else, including a 401 that carries no code. */
  OTHER: "other"
};

// api-v2 `#nsr`, json-api `#nf`, json-api feed `#ntfnd`.
const NO_MEMBER_CODES = ["nsr", "nf", "ntfnd"];

// api-v2 `#nhdr` `#cntdcd` `#tkn`, json-api feed `#ntkn` `#xcptn`, json-api `#xcptn`.
const TOKEN_CODES = ["nhdr", "cntdcd", "tkn", "xcptn", "ntkn"];

/**
 * @param {Object} error an axios error from a request that was answered
 * @returns {string} one of UNAUTHORIZED_REASON
 */
export function getUnauthorizedReason(error) {
  const message = error?.response?.data?.error;
  if (typeof message !== "string") {
    return UNAUTHORIZED_REASON.OTHER;
  }

  const separator = message.lastIndexOf("#");
  if (separator === -1) {
    return UNAUTHORIZED_REASON.OTHER;
  }

  const code = message.slice(separator + 1);
  if (NO_MEMBER_CODES.includes(code)) {
    return UNAUTHORIZED_REASON.NO_MEMBER;
  }
  if (TOKEN_CODES.includes(code)) {
    return UNAUTHORIZED_REASON.TOKEN;
  }

  return UNAUTHORIZED_REASON.OTHER;
}
